import type { ReactNode } from 'react';
import { cn } from '@/libs/utils/cn';

interface ErrorStateProps {
  icon?: ReactNode;

  title?: ReactNode;

  description?: ReactNode;

  actions?: ReactNode;

  className?: string;
}

export function ErrorState(props: ErrorStateProps) {
  const { icon, title, description, actions, className } = props;

  return (
    <div
      className={cn(
        'mx-auto flex max-w-md flex-col items-center justify-center gap-2 p-8 text-center',
        className,
      )}
    >
      <div>{icon}</div>

      {title && <div className="leading-none tracking-tight">{title}</div>}

      {description && <div className="text-muted-foreground text-sm">{description}</div>}

      {actions && <div className="flex gap-2 justify-center">{actions}</div>}
    </div>
  );
}
